import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
export var checkHtmlIsOnlyWhiteSpace = function checkHtmlIsOnlyWhiteSpace(htmlStr) {
  if (typeof htmlStr !== 'string') {
    return false;
  }
  var div = document.createElement('div');
  div.innerHTML = htmlStr;
  return checkIfNodeIsOnlyWhitespace(div);
};
var checkIfNodeIsOnlyWhitespace = function checkIfNodeIsOnlyWhitespace(el) {
  return el.textContent === null || el.textContent.trim() === '';
};
var checkIfSelfClosingNode = function checkIfSelfClosingNode(el) {
  return el instanceof HTMLElement && el.tagName === 'IMG';
};
export var trimHtml = function trimHtml(htmlStr) {
  var trimmedHtml = recursivelyTrimTrailingWhitespaceFromHTML(recursivelyTrimLeadingWhitespaceFromHTML(htmlStr));
  if (trimmedHtml === '') {
    return '<p><br></p>';
  }
  return trimmedHtml;
};

/**
 * Trims leading whitespace from an HTML string, accounting for edge cases such
 * as nested tags, empty tags, etc.
 *
 * Basic algorithm:
 * 1. Creates a div and sets the innerHTML to the provided string, effectively parsing the HTML
 * 2. Loops over every child node of the div and starts creating a new div
 * 3. Only appends the child node if the child has content OR if we have finished trimming the beginning
 * 4. Before appending the child, it also trims the child if we haven't finished trimming the beginning
 */
var recursivelyTrimLeadingWhitespaceFromHTML = function recursivelyTrimLeadingWhitespaceFromHTML(htmlStr) {
  var div = document.createElement('div');
  var newDiv = document.createElement('div');
  var doneTrimmingBeginning = false;
  div.innerHTML = htmlStr || '';
  var divChildNodes = Array.from(div.childNodes);
  for (var _i = 0, _divChildNodes = divChildNodes; _i < _divChildNodes.length; _i++) {
    var childNode = _divChildNodes[_i];
    var clone = childNode.cloneNode(true);
    if (doneTrimmingBeginning) {
      newDiv.appendChild(clone);
      continue;
    }
    var cloneHasContent = !checkIfNodeIsOnlyWhitespace(clone);
    if (cloneHasContent || checkIfSelfClosingNode(clone)) {
      if (checkIfSelfClosingNode(clone)) {
        newDiv.appendChild(clone);
      } else if (clone instanceof HTMLElement) {
        var trimmedCloneHTML = recursivelyTrimLeadingWhitespaceFromHTML(clone.innerHTML);
        clone.innerHTML = trimmedCloneHTML;
        newDiv.appendChild(clone);
      } else if (clone.nodeType === Node.TEXT_NODE && typeof clone.textContent === 'string') {
        clone.textContent = clone.textContent.replace(/^\s+/g, '');
        newDiv.appendChild(clone);
      } else {
        newDiv.appendChild(clone);
      }
      doneTrimmingBeginning = true;
    }
  }
  return newDiv.innerHTML;
};

/**
 * Trims trailing whitespace from an HTML string, accounting for edge cases such
 * as nested tags, empty tags, etc.
 */
var recursivelyTrimTrailingWhitespaceFromHTML = function recursivelyTrimTrailingWhitespaceFromHTML(htmlStr) {
  var div = document.createElement('div');
  var newDiv = document.createElement('div');
  var doneTrimmingEnd = false;
  div.innerHTML = htmlStr || '';
  var divChildNodes = Array.from(div.childNodes);
  for (var i = divChildNodes.length - 1; i >= 0; i--) {
    var childNode = divChildNodes[i];
    var clone = childNode.cloneNode(true);
    if (doneTrimmingEnd) {
      newDiv.prepend(clone);
      continue;
    }
    var cloneHasContent = !checkIfNodeIsOnlyWhitespace(clone);
    if (cloneHasContent || checkIfSelfClosingNode(clone)) {
      if (checkIfSelfClosingNode(clone)) {
        newDiv.prepend(clone);
      } else if (clone instanceof HTMLElement) {
        var trimmedCloneHTML = recursivelyTrimTrailingWhitespaceFromHTML(clone.innerHTML);
        clone.innerHTML = trimmedCloneHTML;
        newDiv.prepend(clone);
      } else if (clone.nodeType === Node.TEXT_NODE && typeof clone.textContent === 'string') {
        clone.textContent = clone.textContent.replace(/\s+$/g, '');
        newDiv.prepend(clone);
      } else {
        newDiv.prepend(clone);
      }
      doneTrimmingEnd = true;
    }
  }
  return newDiv.innerHTML;
};